import { createFileRoute } from '@tanstack/react-router'
import { loaderScope } from '~/features/people/queries'
import {
  SURFACE_PARAM,
  VENUE_PARAM,
  isCompetition,
  playerStatsQuery,
  surfaceOfParam,
  teamStatsQuery,
  venueOfParam,
  type Competition,
  type StatsFilter,
} from '~/features/stats/queries'
import { StatsPage } from '~/features/stats/StatsPage'

type Search = { tab?: 'spieler'; wettbewerb?: Competition; ort?: string; untergrund?: string }

const filterOf = (s: Search): StatsFilter => {
  const venue = venueOfParam(s.ort)
  const surface = surfaceOfParam(s.untergrund)
  return { competition: s.wettbewerb ?? 'competitive', ...(venue ? { venue } : {}), ...(surface ? { surface } : {}) }
}

export const Route = createFileRoute('/_app/kader/statistik')({
  validateSearch: (s: Record<string, unknown>): Search => {
    const venue = venueOfParam(s.ort)
    const surface = surfaceOfParam(s.untergrund)
    return {
      ...(s.tab === 'spieler' ? { tab: 'spieler' as const } : {}),
      ...(isCompetition(s.wettbewerb) && s.wettbewerb !== 'competitive' ? { wettbewerb: s.wettbewerb } : {}),
      ...(venue ? { ort: VENUE_PARAM[venue] } : {}),
      ...(surface ? { untergrund: SURFACE_PARAM[surface] } : {}),
    }
  },
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps }) => {
    const scope = await loaderScope(context.queryClient)
    if (!scope?.teamId) return
    const qc = context.queryClient
    await (deps.tab === 'spieler'
      ? qc.ensureQueryData(playerStatsQuery(scope.teamId, scope.season, filterOf(deps)))
      : qc.ensureQueryData(teamStatsQuery(scope.teamId, scope.season, filterOf(deps)))
    ).catch(() => undefined)
  },
  component: function Stats() {
    const s = Route.useSearch()
    return <StatsPage tab={s.tab === 'spieler' ? 'spieler' : 'team'} filter={filterOf(s)} />
  },
})
